import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { getApiUrl } from '../config/api';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

const obtenerFechaHoy = () => new Date().toISOString().split('T')[0];

const formatearFecha = (fecha) => {
    if (!fecha) return '';
    const [year, month, day] = fecha.split('-');
    return `${day}/${month}/${year}`;
};

const formatearNumero = (valor, decimales = 0) => {
    if (valor == null) return '0';
    return Number(valor).toLocaleString('es-PY', { minimumFractionDigits: decimales, maximumFractionDigits: decimales });
};

function FPresupuesto({ usuario }) {
    const [presupuestos, setPresupuestos] = useState([]);
    const [presupuestosFiltrados, setPresupuestosFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);

    // Detalle (items en memoria antes de guardar)
    const [detalles, setDetalles] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState(null);
    const [detalleTemp, setDetalleTemp] = useState({ cantidad: 1, precio: 0, porcDescuento: 0, gravada: 0, idPresent: 'UN' });

    // Catalogos
    const [clientes, setClientes] = useState([]);
    const [vendedores, setVendedores] = useState([]);
    const [formasPago, setFormasPago] = useState([]);
    const [monedas, setMonedas] = useState([]);
    const [depositos, setDepositos] = useState([]);
    const [listasPrecios, setListasPrecios] = useState([]);
    const [sucursales, setSucursales] = useState([]);

    // Selectores activos
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [vendedorSeleccionado, setVendedorSeleccionado] = useState(null);
    const [dropdownClienteAbierto, setDropdownClienteAbierto] = useState(false);
    const [dropdownVendedorAbierto, setDropdownVendedorAbierto] = useState(false);
    const [dropdownProductoAbierto, setDropdownProductoAbierto] = useState(false);
    const [busquedaCliente, setBusquedaCliente] = useState('');
    const [busquedaVendedor, setBusquedaVendedor] = useState('');
    const [busquedaProducto, setBusquedaProducto] = useState('');
    const [productosEncontrados, setProductosEncontrados] = useState([]);

    const dropdownClienteRef = useRef(null);
    const dropdownVendedorRef = useRef(null);
    const dropdownProductoRef = useRef(null);

    const [formulario, setFormulario] = useState({
        idSucursal: 1, tipoDoc: 'PRE', versionn: 1, boca: 1,
        idCliente: '', nomCliente: '', rucCliente: '', direccion: '', telefono: '',
        fecha: obtenerFechaHoy(), vence: obtenerFechaHoy(),
        idVendedor: '', idFormapago: '',
        idLisprecio: '', idMoneda: '', cambio: 1,
        idDeposito: 1, ordenCompra: '', plazoEntrega: '', obs: '', obra: ''
    });

    // Modal Ver
    const [modalVerAbierto, setModalVerAbierto] = useState(false);
    const [presupuestoVer, setPresupuestoVer] = useState(null);
    const [detallesVer, setDetallesVer] = useState([]);

    // Paginacion
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(20);

    useEffect(() => { cargarPresupuestos(); cargarDatosSelectores(); }, []);
    useEffect(() => { filtrarPresupuestos(); }, [busqueda, presupuestos]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownClienteRef.current && !dropdownClienteRef.current.contains(event.target)) setDropdownClienteAbierto(false);
            if (dropdownVendedorRef.current && !dropdownVendedorRef.current.contains(event.target)) setDropdownVendedorAbierto(false);
            if (dropdownProductoRef.current && !dropdownProductoRef.current.contains(event.target)) setDropdownProductoAbierto(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const cargarPresupuestos = async () => {
        try {
            const r = await axios.get(getApiUrl('/api/presupuestos'));
            setPresupuestos(r.data);
        } catch (e) { console.error('Error:', e); alert('Error al cargar presupuestos'); }
    };

    const cargarDatosSelectores = async () => {
        try {
            const [r1, r2, r3, r4, r5, r6, r7] = await Promise.all([
                axios.get(getApiUrl('/api/clientes')),
                axios.get(getApiUrl('/api/vendedores')),
                axios.get(getApiUrl('/api/fpago')),
                axios.get(getApiUrl('/api/monedas')),
                axios.get(getApiUrl('/api/depositos')),
                axios.get(getApiUrl('/api/listas-precio')),
                axios.get(getApiUrl('/api/sucursales'))
            ]);
            setClientes(r1.data); setVendedores(r2.data); setFormasPago(r3.data);
            setMonedas(r4.data); setDepositos(r5.data); setListasPrecios(r6.data); setSucursales(r7.data);
        } catch (e) { console.error('Error selectores:', e); }
    };

    const filtrarPresupuestos = () => {
        if (!busqueda) { setPresupuestosFiltrados(presupuestos); setPaginaActual(1); return; }
        setPresupuestosFiltrados(presupuestos.filter(p =>
            p.nropresupuesto?.toString().includes(busqueda) ||
            p.nomCliente?.toLowerCase().includes(busqueda.toLowerCase()) ||
            p.rucCliente?.toLowerCase().includes(busqueda.toLowerCase())
        ));
        setPaginaActual(1);
    };

    // Selectores
    const filtrarClientes = (b) => !b ? clientes.slice(0, 50) : clientes.filter(c => c.idCliente?.toString().includes(b) || c.nomCliente?.toLowerCase().includes(b.toLowerCase()) || c.rucCliente?.toLowerCase().includes(b.toLowerCase()));
    const seleccionarCliente = (c) => {
        setClienteSeleccionado(c);
        setFormulario(f => ({
            ...f,
            idCliente: c.idCliente,
            nomCliente: c.nomCliente || '',
            rucCliente: c.rucCliente || '',
            direccion: c.direccion || '',
            telefono: c.telefono || '',
            idVendedor: c.idVendedor || f.idVendedor,
            idFormapago: c.idFormapago || f.idFormapago,
            idLisprecio: c.idLisprecio || f.idLisprecio
        }));
        if (c.idVendedor) { const v = vendedores.find(v => v.idVendedor === c.idVendedor); if (v) setVendedorSeleccionado(v); }
        setBusquedaCliente(''); setDropdownClienteAbierto(false);
    };

    const filtrarVendedores = (b) => !b ? vendedores.slice(0, 50) : vendedores.filter(v => v.idVendedor?.toString().includes(b) || v.nomVendedor?.toLowerCase().includes(b.toLowerCase()));
    const seleccionarVendedor = (v) => { setVendedorSeleccionado(v); setFormulario(f => ({...f, idVendedor: v.idVendedor})); setBusquedaVendedor(''); setDropdownVendedorAbierto(false); };

    // Detalle - calculo IVA (precio incluye IVA)
    const calcularLinea = (cant, precio, descPct, gravada) => {
        const subtotal = precio * cant;
        const descuento = subtotal * (descPct / 100);
        const total = subtotal - descuento;
        let monGravada = 0, monIva = 0, monExenta = 0, monGravada5 = 0, monGravada10 = 0;
        if (gravada === 10) { monGravada = total / 1.10; monIva = total - monGravada; monGravada10 = Math.round(monGravada); }
        else if (gravada === 5) { monGravada = total / 1.05; monIva = total - monGravada; monGravada5 = Math.round(monGravada); }
        else { monExenta = total; }
        return { monGravada: Math.round(monGravada), monIva: Math.round(monIva), monExenta: Math.round(monExenta), monGravada5, monGravada10, total: Math.round(total), descuento: Math.round(descuento) };
    };

    // Busqueda de productos: se espera 250 ms tras la ultima tecla y solo se muestra la respuesta
    // de la ultima busqueda (una respuesta lenta anterior no pisa a la mas reciente).
    const busquedaProductoRef = useRef({ timer: null, secuencia: 0 });
    const buscarProductoAPI = (texto) => {
        const ref = busquedaProductoRef.current;
        clearTimeout(ref.timer);
        if (texto.trim().length < 2) { ref.secuencia++; setProductosEncontrados([]); return; }
        const seq = ++ref.secuencia;
        ref.timer = setTimeout(async () => {
            try {
                const r = await axios.get(getApiUrl('/api/presupuestos/buscar-producto'), { params: { busqueda: texto } });
                if (seq === ref.secuencia) setProductosEncontrados(r.data);
            } catch (e) { console.error(e); }
        }, 250);
    };

    const seleccionarProductoDetalle = async (producto) => {
        setProductoSeleccionado(producto); setProductosEncontrados([]); setDropdownProductoAbierto(false);
        setBusquedaProducto(producto.descripcion);
        let precioConIva = Number(producto.precio) || 0;
        let gravada = Number(producto.gravada) || 0;
        const idLisprecio = formulario.idLisprecio;
        if (idLisprecio) {
            try {
                const r = await axios.get(getApiUrl('/api/presupuestos/precio'), { params: { idLisprecio, idProducto: producto.id_producto } });
                precioConIva = Number(r.data.precio) || precioConIva;
                gravada = Number(r.data.gravada) || gravada;
            } catch (e) { /* usar precio base */ }
        }
        setDetalleTemp({ cantidad: 1, precio: precioConIva, porcDescuento: 0, gravada, idPresent: producto.id_present || 'UN' });
    };

    const agregarDetalle = () => {
        if (!productoSeleccionado) { alert('Seleccione un producto'); return; }
        if (detalleTemp.cantidad <= 0) { alert('La cantidad debe ser mayor a 0'); return; }
        if (detalleTemp.precio <= 0) { alert('El precio debe ser mayor a 0'); return; }
        if (detalles.find(d => d.idProducto === productoSeleccionado.id_producto)) { alert('Producto ya agregado'); return; }

        const calc = calcularLinea(detalleTemp.cantidad, detalleTemp.precio, detalleTemp.porcDescuento, detalleTemp.gravada);
        setDetalles(prev => [...prev, {
            idProducto: productoSeleccionado.id_producto,
            nomProducto: productoSeleccionado.descripcion?.substring(0, 250),
            cantidad: detalleTemp.cantidad, precio: detalleTemp.precio,
            porcDescuento: detalleTemp.porcDescuento, porcIva: detalleTemp.gravada,
            monDesc: calc.descuento, monDetalle: calc.total,
            unidades: detalleTemp.idPresent || 'UN',
            present: '', obs: ''
        }]);
        setProductoSeleccionado(null); setBusquedaProducto('');
        setDetalleTemp({ cantidad: 1, precio: 0, porcDescuento: 0, gravada: 0, idPresent: 'UN' });
    };

    const eliminarDetalle = (idProducto) => { setDetalles(prev => prev.filter(d => d.idProducto !== idProducto)); };

    const calcularTotales = () => {
        let exenta = 0, gravada5 = 0, gravada10 = 0, iva = 0;
        detalles.forEach(d => {
            const c = calcularLinea(d.cantidad, d.precio, d.porcDescuento, d.porcIva);
            exenta += c.monExenta; gravada5 += c.monGravada5; gravada10 += c.monGravada10; iva += c.monIva;
        });
        const total = exenta + gravada5 + gravada10 + iva;
        return { exenta, gravada5, gravada10, iva, gravada: gravada5 + gravada10, total };
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idSucursal: 1, tipoDoc: 'PRE', versionn: 1, boca: 1,
            idCliente: '', nomCliente: '', rucCliente: '', direccion: '', telefono: '',
            fecha: obtenerFechaHoy(), vence: obtenerFechaHoy(),
            idVendedor: '', idFormapago: '',
            idLisprecio: '', idMoneda: '', cambio: 1,
            idDeposito: 1, ordenCompra: '', plazoEntrega: '', obs: '', obra: ''
        });
        setClienteSeleccionado(null); setVendedorSeleccionado(null);
        setDetalles([]); setProductoSeleccionado(null); setBusquedaProducto('');
        setDetalleTemp({ cantidad: 1, precio: 0, porcDescuento: 0, gravada: 0, idPresent: 'UN' });
        setModalAbierto(true);
    };

    const cerrarModal = () => { setModalAbierto(false); };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formulario.idCliente) { alert('Debe seleccionar un cliente'); return; }
        if (!formulario.fecha) { alert('Debe ingresar una fecha'); return; }
        if (!formulario.idMoneda) { alert('Debe seleccionar una moneda'); return; }
        if (!formulario.idLisprecio) { alert('Debe seleccionar una lista de precios'); return; }
        if (detalles.length === 0) { alert('Debe agregar al menos un item'); return; }

        try {
            const totales = calcularTotales();
            const cabecera = {
                ...formulario,
                monExenta: totales.exenta,
                monGravada: totales.gravada,
                monIva: totales.iva,
                monTotal: totales.total
            };
            const response = await axios.post(getApiUrl('/api/presupuestos'), cabecera);
            const creado = response.data;
            const nro = creado.nropresupuesto;

            // Insertar items
            for (const d of detalles) {
                await axios.post(getApiUrl('/api/presupuestos/detalle'), {
                    idSucursal: formulario.idSucursal,
                    tipoDoc: 'PRE',
                    nropresupuesto: nro,
                    versionn: formulario.versionn,
                    idCliente: formulario.idCliente,
                    cambio: formulario.cambio,
                    cantidad: d.cantidad,
                    precio: d.precio,
                    porcDescuento: d.porcDescuento,
                    porcIva: d.porcIva,
                    monDesc: d.monDesc,
                    monDetalle: d.monDetalle,
                    idProducto: d.idProducto,
                    nomProducto: d.nomProducto,
                    unidades: d.unidades,
                    present: d.present,
                    obs: d.obs
                });
            }
            alert('Presupuesto Nro ' + nro + ' creado exitosamente con ' + detalles.length + ' items');
            cerrarModal();
            cargarPresupuestos();
        } catch (error) {
            const msg = error.response?.data || 'Error al crear presupuesto';
            alert(typeof msg === 'string' ? msg : 'Error al crear presupuesto');
        }
    };

    const verPresupuesto = async (p) => {
        setPresupuestoVer(p);
        try {
            const r = await axios.get(getApiUrl('/api/presupuestos/detalle'), {
                params: { idSucursal: p.idSucursal, tipoDoc: p.tipoDoc, nropresupuesto: p.nropresupuesto, versionn: p.versionn }
            });
            setDetallesVer(r.data);
        } catch (e) { setDetallesVer([]); }
        setModalVerAbierto(true);
    };

    const imprimirPresupuesto = (p) => {
        const params = new URLSearchParams({
            nropresupuesto: String(p.nropresupuesto || ''),
            versionn: String(p.versionn || 1),
            idCliente: String(p.idCliente || 0),
            nomEmpresa: p.nomEmpresa || '',
            montoDescuento: String(p.monDesc || 0),
            totalPresupuesto: String(p.monTotal || 0)
        });
        const url = getApiUrl('/api/presupuestos/imprimir') + '?' + params.toString();
        window.open(url, '_blank');
    };

    const anularPresupuesto = async (p) => {
        if (p.estado === 'A') { alert('Ya esta anulado'); return; }
        if (!window.confirm('Anular el presupuesto Nro ' + p.nropresupuesto + '?')) return;
        try {
            await axios.put(getApiUrl('/api/presupuestos/anular'), null, {
                params: { idSucursal: p.idSucursal, tipoDoc: p.tipoDoc, nropresupuesto: p.nropresupuesto, versionn: p.versionn }
            });
            alert('Presupuesto anulado');
            cargarPresupuestos();
        } catch (error) {
            const msg = error.response?.data || 'Error al anular';
            alert(typeof msg === 'string' ? msg : 'Error al anular');
        }
    };

    const exportarExcel = () => {
        const d = presupuestosFiltrados.map(p => ({
            'Nro': p.nropresupuesto, 'Version': p.versionn, 'Fecha': p.fecha ? formatearFecha(p.fecha) : '',
            'Cliente': p.nomCliente, 'RUC': p.rucCliente, 'Total': p.monTotal, 'Estado': p.estado, 'Facturado': p.facturado
        }));
        const ws = XLSX.utils.json_to_sheet(d); const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Presupuestos'); XLSX.writeFile(wb, 'presupuestos.xlsx');
    };

    // Paginacion
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const presupuestosActuales = presupuestosFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(presupuestosFiltrados.length / itemsPorPagina);

    const previewLinea = productoSeleccionado ? calcularLinea(detalleTemp.cantidad, detalleTemp.precio, detalleTemp.porcDescuento, detalleTemp.gravada) : null;
    const totales = calcularTotales();

    return (
        <div className="gestion-producto-container">
            <div className="header-seccion">
                <h2>Presupuestos a Clientes</h2>
                <div className="acciones-header">
                    <input type="text" className="input-busqueda" placeholder="Buscar..." value={busqueda} onChange={(e) => setBusqueda(e.target.value)} />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>+ Nuevo Presupuesto</button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>Exportar Excel</button>
                </div>
            </div>

            {/* Grilla presupuestos */}
            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead><tr>
                        <th>Numero</th><th>Ver</th><th>Fecha</th><th>Vence</th><th>Cliente</th><th>RUC</th>
                        <th style={{textAlign:'right'}}>Total</th><th>Moneda</th><th>Estado</th><th>Facturado</th><th>Acc</th>
                    </tr></thead>
                    <tbody>
                        {presupuestosActuales.length === 0 ? (
                            <tr><td colSpan="11" className="sin-datos">No hay presupuestos</td></tr>
                        ) : presupuestosActuales.map((p, i) => (
                            <tr key={i}>
                                <td>{String(p.idSucursal).padStart(3,'0')}-{String(p.boca).padStart(3,'0')}-{p.nropresupuesto}</td>
                                <td>v{p.versionn}</td>
                                <td>{p.fecha ? formatearFecha(p.fecha) : ''}</td>
                                <td>{p.vence ? formatearFecha(p.vence) : ''}</td>
                                <td>{p.nomCliente}</td>
                                <td>{p.rucCliente}</td>
                                <td style={{textAlign:'right'}}>{formatearNumero(p.monTotal)}</td>
                                <td>{p.idMoneda}</td>
                                <td style={p.estado === 'A' ? { color: '#c62828', fontWeight: 'bold' } : {}}>
                                    {p.estado === 'A' ? 'Anulado' : p.estado === 'C' ? 'Cerrado' : 'Abierto'}
                                </td>
                                <td>{p.facturado === 'S' ? 'Si' : 'No'}</td>
                                <td>
                                    <button type="button" onClick={() => verPresupuesto(p)} className="btn-accion" title="Ver">👁</button>
                                    <button type="button" onClick={() => imprimirPresupuesto(p)} className="btn-accion" title="Imprimir presupuesto (PDF)"
                                        style={{ color: '#2DCCD3' }}>🖨️</button>
                                    <button type="button" onClick={() => anularPresupuesto(p)} className="btn-accion" title="Anular"
                                        disabled={p.estado === 'A'} style={p.estado === 'A' ? { opacity: 0.3 } : { color: '#c62828' }}>✕</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Paginacion */}
            {presupuestosFiltrados.length > 0 && (
                <div className="paginacion-container">
                    <div className="paginacion-info">
                        <span>Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, presupuestosFiltrados.length)} de {presupuestosFiltrados.length}</span>
                        <select value={itemsPorPagina} onChange={(e) => { setItemsPorPagina(Number(e.target.value)); setPaginaActual(1); }} className="select-registros">
                            <option value={10}>10</option><option value={20}>20</option><option value={50}>50</option>
                        </select>
                    </div>
                    <div className="paginacion-controles">
                        <button onClick={() => setPaginaActual(1)} disabled={paginaActual === 1} className="btn-paginacion">|&lt;</button>
                        <button onClick={() => setPaginaActual(p => p - 1)} disabled={paginaActual === 1} className="btn-paginacion">&lt;</button>
                        <button onClick={() => setPaginaActual(p => p + 1)} disabled={paginaActual >= totalPaginas} className="btn-paginacion">&gt;</button>
                        <button onClick={() => setPaginaActual(totalPaginas)} disabled={paginaActual >= totalPaginas} className="btn-paginacion">&gt;|</button>
                    </div>
                </div>
            )}

            {/* ====== MODAL NUEVO PRESUPUESTO ====== */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido-grande" style={{ maxWidth: '1100px' }}>
                        <div className="modal-header">
                            <h3>Nuevo Presupuesto</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">&times;</button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                {/* Cabecera */}
                                <div className="form-section">
                                    <h3>Datos de Cabecera</h3>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                        <div>
                                            <div className="form-group">
                                                <label>Sucursal *</label>
                                                <select value={formulario.idSucursal} onChange={(e) => setFormulario(f => ({...f, idSucursal: Number(e.target.value)}))}
                                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                                    {sucursales.map(s => (<option key={s.idSucursal} value={s.idSucursal}>{s.idSucursal} - {s.nombre}</option>))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Cliente *</label>
                                                <div className="cuenta-selector" ref={dropdownClienteRef}>
                                                    {clienteSeleccionado ? (
                                                        <div className="cuenta-seleccionada">
                                                            <span>{clienteSeleccionado.idCliente} - {clienteSeleccionado.nomCliente}</span>
                                                            <button type="button" onClick={() => { setClienteSeleccionado(null); setFormulario(f => ({...f, idCliente:'', nomCliente:'', rucCliente:'', direccion:'', telefono:''})); }} className="btn-limpiar">✕</button>
                                                        </div>
                                                    ) : (
                                                        <input type="text" placeholder="Buscar cliente..." value={busquedaCliente} onChange={(e) => setBusquedaCliente(e.target.value)} onFocus={() => setDropdownClienteAbierto(true)} className="form-input" />
                                                    )}
                                                    {dropdownClienteAbierto && !clienteSeleccionado && (
                                                        <div className="cuenta-dropdown">
                                                            {filtrarClientes(busquedaCliente).map(c => (
                                                                <div key={c.idCliente} className="cuenta-item" onClick={() => seleccionarCliente(c)}>
                                                                    <strong>{c.idCliente}</strong> - {c.nomCliente} ({c.rucCliente})
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label>Fecha *</label>
                                                <input type="date" value={formulario.fecha} onChange={(e) => setFormulario(f => ({...f, fecha: e.target.value}))} className="form-input" />
                                            </div>
                                            <div className="form-group">
                                                <label>Vence</label>
                                                <input type="date" value={formulario.vence} onChange={(e) => setFormulario(f => ({...f, vence: e.target.value}))} className="form-input" />
                                            </div>
                                            <div className="form-group">
                                                <label>Forma de Pago</label>
                                                <select value={formulario.idFormapago} onChange={(e) => setFormulario(f => ({...f, idFormapago: e.target.value}))}
                                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                                    <option value="">-- Seleccione --</option>
                                                    {formasPago.map(fp => (<option key={fp.idFpago} value={fp.idFpago}>{fp.idFpago}</option>))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Orden de Compra</label>
                                                <input type="text" value={formulario.ordenCompra} onChange={(e) => setFormulario(f => ({...f, ordenCompra: e.target.value}))} maxLength={12} className="form-input" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="form-group">
                                                <label>Lista de Precios *</label>
                                                <select value={formulario.idLisprecio || ''} onChange={(e) => setFormulario(f => ({...f, idLisprecio: e.target.value ? Number(e.target.value) : null}))}
                                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                                    <option value="">-- Seleccione --</option>
                                                    {listasPrecios.map(lp => (<option key={lp.idLisprecio} value={lp.idLisprecio}>{lp.idLisprecio} - {lp.obs || 'Sin desc'}</option>))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Vendedor</label>
                                                <div className="cuenta-selector" ref={dropdownVendedorRef}>
                                                    {vendedorSeleccionado ? (
                                                        <div className="cuenta-seleccionada">
                                                            <span>{vendedorSeleccionado.idVendedor} - {vendedorSeleccionado.nomVendedor}</span>
                                                            <button type="button" onClick={() => { setVendedorSeleccionado(null); setFormulario(f => ({...f, idVendedor:''})); }} className="btn-limpiar">✕</button>
                                                        </div>
                                                    ) : (
                                                        <input type="text" placeholder="Buscar vendedor..." value={busquedaVendedor} onChange={(e) => setBusquedaVendedor(e.target.value)} onFocus={() => setDropdownVendedorAbierto(true)} className="form-input" />
                                                    )}
                                                    {dropdownVendedorAbierto && !vendedorSeleccionado && (
                                                        <div className="cuenta-dropdown">
                                                            {filtrarVendedores(busquedaVendedor).map(v => (
                                                                <div key={v.idVendedor} className="cuenta-item" onClick={() => seleccionarVendedor(v)}>
                                                                    <strong>{v.idVendedor}</strong> - {v.nomVendedor}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label>Moneda *</label>
                                                <select value={formulario.idMoneda} onChange={(e) => { const es = e.target.value === 'GS'; setFormulario(f => ({...f, idMoneda: e.target.value, cambio: es ? 1 : 0})); }}
                                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                                    <option value="">-- Seleccione --</option>
                                                    {monedas.map(m => (<option key={m.idMoneda} value={m.idMoneda}>{m.idMoneda} - {m.nomMoneda}</option>))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Tipo de Cambio</label>
                                                <input type="number" value={formulario.cambio} onChange={(e) => setFormulario(f => ({...f, cambio: Number(e.target.value)}))} disabled={formulario.idMoneda === 'GS'}
                                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', backgroundColor: formulario.idMoneda === 'GS' ? '#f0f0f0' : 'white' }} />
                                            </div>
                                            <div className="form-group">
                                                <label>Deposito</label>
                                                <select value={formulario.idDeposito} onChange={(e) => setFormulario(f => ({...f, idDeposito: Number(e.target.value)}))}
                                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                                    {depositos.map(d => (<option key={d.idDeposito} value={d.idDeposito}>{d.idDeposito} - {d.nomDepto}</option>))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Plazo de Entrega</label>
                                                <input type="text" value={formulario.plazoEntrega} onChange={(e) => setFormulario(f => ({...f, plazoEntrega: e.target.value}))} maxLength={12} className="form-input" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Observaciones</label>
                                        <textarea value={formulario.obs} onChange={(e) => setFormulario(f => ({...f, obs: e.target.value}))} maxLength={250} rows="2" className="form-input" />
                                    </div>
                                    <div className="form-group">
                                        <label>Obra</label>
                                        <textarea value={formulario.obra} onChange={(e) => setFormulario(f => ({...f, obra: e.target.value}))} maxLength={700} rows="2" className="form-input" />
                                    </div>
                                </div>

                                {/* Detalle */}
                                <div className="form-section" style={{ marginTop: '20px' }}>
                                    <h3>Items del Presupuesto</h3>
                                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr auto', gap: '10px', alignItems: 'end' }}>
                                        <div className="form-group">
                                            <label>Producto *</label>
                                            <div className="cuenta-selector" ref={dropdownProductoRef}>
                                                {productoSeleccionado ? (
                                                    <div className="cuenta-seleccionada">
                                                        <span><strong>{productoSeleccionado.id_producto}</strong> - {productoSeleccionado.descripcion}</span>
                                                        <button type="button" onClick={() => { setProductoSeleccionado(null); setBusquedaProducto(''); setDetalleTemp({cantidad:1,precio:0,porcDescuento:0,gravada:0,idPresent:'UN'}); }} className="btn-limpiar">✕</button>
                                                    </div>
                                                ) : (
                                                    <input type="text" placeholder="Buscar producto..." value={busquedaProducto}
                                                        onChange={(e) => { setBusquedaProducto(e.target.value); buscarProductoAPI(e.target.value); }}
                                                        onFocus={() => setDropdownProductoAbierto(true)} className="form-input" />
                                                )}
                                                {dropdownProductoAbierto && !productoSeleccionado && productosEncontrados.length > 0 && (
                                                    <div className="cuenta-dropdown">
                                                        {productosEncontrados.map((p, i) => (
                                                            <div key={i} className="cuenta-item" onClick={() => seleccionarProductoDetalle(p)}>
                                                                <strong>{p.id_producto}</strong> - {p.descripcion} {p.gravada > 0 && <span style={{color:'#7f8c8d',fontSize:'11px'}}>(IVA {p.gravada}%)</span>}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label>Cantidad</label>
                                            <input type="number" value={detalleTemp.cantidad} min="0" step="1" onChange={(e) => setDetalleTemp(d => ({...d, cantidad: Number(e.target.value)}))} className="form-input" />
                                        </div>
                                        <div className="form-group">
                                            <label>Precio (c/IVA)</label>
                                            <input type="number" value={detalleTemp.precio} min="0" step="100" onChange={(e) => setDetalleTemp(d => ({...d, precio: Number(e.target.value)}))} className="form-input" />
                                        </div>
                                        <div className="form-group">
                                            <label>Desc %</label>
                                            <input type="number" value={detalleTemp.porcDescuento} min="0" max="100" step="0.5" onChange={(e) => setDetalleTemp(d => ({...d, porcDescuento: Number(e.target.value)}))} className="form-input" />
                                        </div>
                                        <div className="form-group">
                                            <button type="button" onClick={agregarDetalle} className="btn btn-nuevo" style={{ marginTop: '5px' }} disabled={!productoSeleccionado}>+ Agregar</button>
                                        </div>
                                    </div>

                                    {previewLinea && productoSeleccionado && (
                                        <div style={{ display: 'flex', gap: '20px', padding: '8px 15px', backgroundColor: '#EDF1FB', borderRadius: '6px', marginTop: '5px', fontSize: '13px' }}>
                                            <span>Exenta: <strong>{formatearNumero(previewLinea.monExenta)}</strong></span>
                                            <span>Gravada 5%: <strong>{formatearNumero(previewLinea.monGravada5)}</strong></span>
                                            <span>Gravada 10%: <strong>{formatearNumero(previewLinea.monGravada10)}</strong></span>
                                            <span>IVA: <strong>{formatearNumero(previewLinea.monIva)}</strong></span>
                                            <span style={{ color: '#2DCCD3' }}>Total: <strong>{formatearNumero(previewLinea.total)}</strong></span>
                                        </div>
                                    )}

                                    <div style={{ marginTop: '15px' }}>
                                        <table className="tabla-datos" style={{ fontSize: '13px' }}>
                                            <thead><tr><th>Producto</th><th>Descripcion</th><th style={{textAlign:'right'}}>Cant</th><th style={{textAlign:'right'}}>Precio</th><th style={{textAlign:'right'}}>Desc%</th><th style={{textAlign:'right'}}>Total</th><th>Acc</th></tr></thead>
                                            <tbody>
                                                {detalles.length === 0 ? (
                                                    <tr><td colSpan="7" className="sin-datos">No hay items</td></tr>
                                                ) : detalles.map((d, i) => (
                                                    <tr key={i}>
                                                        <td>{d.idProducto}</td><td>{d.nomProducto}</td>
                                                        <td style={{textAlign:'right'}}>{formatearNumero(d.cantidad)}</td>
                                                        <td style={{textAlign:'right'}}>{formatearNumero(d.precio)}</td>
                                                        <td style={{textAlign:'right'}}>{d.porcDescuento > 0 ? d.porcDescuento.toFixed(2)+'%' : '0'}</td>
                                                        <td style={{textAlign:'right', fontWeight:'bold', color:'#001A70'}}>{formatearNumero(d.monDetalle)}</td>
                                                        <td><button type="button" onClick={() => eliminarDetalle(d.idProducto)} className="btn-accion" title="Eliminar">🗑</button></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                                                    <td colSpan="5" style={{textAlign:'right'}}>TOTAL:</td>
                                                    <td style={{textAlign:'right', color:'#2DCCD3'}}>{formatearNumero(totales.total)}</td>
                                                    <td></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <button type="button" onClick={cerrarModal} className="btn-secondary">Cancelar</button>
                                    <button type="submit" className="btn-primary">Guardar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* ====== MODAL VER PRESUPUESTO ====== */}
            {modalVerAbierto && presupuestoVer && (
                <div className="modal-overlay">
                    <div className="modal-contenido-grande" style={{ maxWidth: '1100px' }}>
                        <div className="modal-header">
                            <h3>Presupuesto Nro {presupuestoVer.nropresupuesto} (v{presupuestoVer.versionn})</h3>
                            <button onClick={() => setModalVerAbierto(false)} className="btn-cerrar">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="form-section">
                                <h3>Datos de Cabecera</h3>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', fontSize: '14px' }}>
                                    <div><strong>Sucursal:</strong> {presupuestoVer.idSucursal}</div>
                                    <div><strong>Numero:</strong> {presupuestoVer.nropresupuesto}</div>
                                    <div><strong>Version:</strong> {presupuestoVer.versionn}</div>
                                    <div><strong>Fecha:</strong> {presupuestoVer.fecha ? formatearFecha(presupuestoVer.fecha) : ''}</div>
                                    <div><strong>Vence:</strong> {presupuestoVer.vence ? formatearFecha(presupuestoVer.vence) : ''}</div>
                                    <div><strong>Cliente:</strong> {presupuestoVer.nomCliente}</div>
                                    <div><strong>RUC:</strong> {presupuestoVer.rucCliente}</div>
                                    <div><strong>Moneda:</strong> {presupuestoVer.idMoneda}</div>
                                    <div><strong>Cambio:</strong> {presupuestoVer.cambio}</div>
                                    <div><strong>Forma Pago:</strong> {presupuestoVer.idFormapago}</div>
                                    <div><strong>Vendedor:</strong> {presupuestoVer.idVendedor}</div>
                                    <div><strong>Estado:</strong> {presupuestoVer.estado === 'A' ? 'Anulado' : 'Activo'}</div>
                                </div>
                                {presupuestoVer.obs && <div style={{ marginTop: '10px' }}><strong>Obs:</strong> {presupuestoVer.obs}</div>}
                                {presupuestoVer.obra && <div style={{ marginTop: '5px' }}><strong>Obra:</strong> {presupuestoVer.obra}</div>}
                            </div>

                            <div className="form-section" style={{ marginTop: '20px' }}>
                                <h3>Items</h3>
                                <table className="tabla-datos" style={{ fontSize: '13px' }}>
                                    <thead><tr><th>Producto</th><th>Descripcion</th><th style={{textAlign:'right'}}>Cant</th><th style={{textAlign:'right'}}>Precio</th><th style={{textAlign:'right'}}>Desc%</th><th style={{textAlign:'right'}}>Total</th></tr></thead>
                                    <tbody>
                                        {detallesVer.length === 0 ? (
                                            <tr><td colSpan="6" className="sin-datos">Sin items</td></tr>
                                        ) : detallesVer.map((d, i) => (
                                            <tr key={i}>
                                                <td>{d.idProducto}</td><td>{d.nomProducto}</td>
                                                <td style={{textAlign:'right'}}>{formatearNumero(d.cantidad)}</td>
                                                <td style={{textAlign:'right'}}>{formatearNumero(d.precio)}</td>
                                                <td style={{textAlign:'right'}}>{Number(d.porcDescuento) > 0 ? Number(d.porcDescuento).toFixed(2)+'%' : '0'}</td>
                                                <td style={{textAlign:'right', fontWeight:'bold', color:'#001A70'}}>{formatearNumero(d.monDetalle)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '25px', marginTop: '15px', padding: '15px', backgroundColor: '#EDF1FB', borderRadius: '8px', fontSize: '15px' }}>
                                <div><strong>Exenta:</strong> {formatearNumero(presupuestoVer.monExenta)}</div>
                                <div><strong>Gravada:</strong> {formatearNumero(presupuestoVer.monGravada)}</div>
                                <div><strong>IVA:</strong> {formatearNumero(presupuestoVer.monIva)}</div>
                                <div style={{ color: '#001A70', fontSize: '18px' }}><strong>TOTAL: {formatearNumero(presupuestoVer.monTotal)}</strong></div>
                            </div>

                            <div className="form-actions" style={{ marginTop: '15px' }}>
                                <button type="button" onClick={() => setModalVerAbierto(false)} className="btn-primary">Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default FPresupuesto;
